const URL_BASE = window.s3_config_port

const URL_LOGIN = `${URL_BASE}/authService/login`
const URL_GET_ITEMS = `${URL_BASE}/api/protected/getItems`
const URL_REGISTER_VIEW = `${URL_BASE}/api/protected/registerView`

const URL_EDIT_ITEM = `${URL_BASE}/api/protected/editItem`
const URL_MOVE_ITEM = `${URL_BASE}/api/protected/moveItem`
const URL_HIDE_ITEM = `${URL_BASE}/api/protected/hideItem`
const URL_UNHIDE_ITEM = `${URL_BASE}/api/protected/unHideItem`
const URL_REMOVE_ITEM = `${URL_BASE}/api/protected/removeItem`
const URL_UNDO_REMOVE_ITEM = `${URL_BASE}/api/protected/unDoRemoveItem`
const URL_ADD_ITEM = `${URL_BASE}/api/protected/addItem`
const URL_SET_FAVORITE = `${URL_BASE}/api/protected/setFavorite`

const URL_UPDATE_USER_INFO = `${URL_BASE}/api/protected/updateUserInfo`
const URL_UPDATE_USER_PASSWORD = `${URL_BASE}/api/protected/updateUserPassword`

const URL_GET_ADMIN_USERS = `${URL_BASE}/api/protected/admin/getUsers`
const URL_GET_ADMIN_SUBSCRIPTIONS = `${URL_BASE}/api/protected/admin/getSubscriptions`
const URL_GET_ADMIN_FOLDERS_SUBSCRIPTIONS = `${URL_BASE}/api/protected/admin/getFoldersSubscriptions`
const URL_UPDATE_SUBSCRIPTIONS = `${URL_BASE}/api/protected/admin/updateSubscriptions`
const URL_ADMIN_UPDATE_USER_INFO = `${URL_BASE}/api/protected/admin/updateUserInfo`
const URL_ADMIN_UPDATE_USER_PASSWORD = `${URL_BASE}/api/protected/admin/updateUserPassword`
const URL_ADMIN_UPDATE_ACCESS_LEVEL = `${URL_BASE}/api/protected/admin/updateAccessLevel`
const URL_ADMIN_CREATE_USER = `${URL_BASE}/api/protected/admin/createUser`

const URL_CREATE_STRUCTURE = `${URL_BASE}/api/protected/structures/createStructure`
const URL_CHECK_STRUCTURE_NAME = `${URL_BASE}/api/protected/structures/checkStructureName`
const URL_GET_STRUCTURES = `${URL_BASE}/api/protected/structures/getStructures`
const URL_BUILD_STRUCTURE = `${URL_BASE}/api/protected/structures/buildStructure`
const URL_CREATE_HERITABLE_ITEM = `${URL_BASE}/api/protected/structures/createHeritableItem`
const URL_UPDATE_HERITABLE_ITEM = `${URL_BASE}/api/protected/structures/updateHeritableItem`
const URL_CREATE_HERITABLE_STRUCTURE = `${URL_BASE}/api/protected/structures/createHeritableStructure`
const URL_REPLICATE_STRUCTURE = `${URL_BASE}/api/protected/structures/replicateStructure`
const URL_REMOVE_STRUCTURE = `${URL_BASE}/api/protected/structures/removeStructure`
const URL_UPDATE_SPECIFIC_ITEM_DATA = `${URL_BASE}/api/protected/structures/updateSpecificItemData`
const URL_REPLICATE_FOLDER = `${URL_BASE}/api/protected/structures/replicateFolder`
const URL_UPDATE_MULTIPLE_ITEMS_INHERITEE = `${URL_BASE}/api/protected/structures/updateMultipleItemsInheritee`
const URL_GET_HERITABLE_ITEMS = `${URL_BASE}/api/protected/getHeritableItems`

const URL_SUPERVISOR_REMOTE_FILES = `${URL_BASE}/api/protected/supervisor/getFiles`
const URL_SUPERVISOR_REMOTE_UPDATE_FILE = `${URL_BASE}/api/protected/supervisor/updateFile`
const URL_SUPERVISOR_REMOTE_REMOVE_FILE = `${URL_BASE}/api/protected/supervisor/removeFile`
const URL_SUPERVISOR_REMOTE_ADD_DISTRIBUTOR = `${URL_BASE}/api/protected/supervisor/addDistributor`
const URL_SUPERVISOR_REMOTE_EDIT_DISTRIBUTOR = `${URL_BASE}/api/protected/supervisor/editDistributor`
const URL_SUPERVISOR_REMOTE_REMOVE_DISTRIBUTOR = `${URL_BASE}/api/protected/supervisor/removeDistributor`
const URL_SUPERVISOR_REMOTE_SEND_INCONSISTENCIES_MAIL = `${URL_BASE}/api/protected/supervisor/sendInconsistenciesMail`

const URL_SUPERVISOR_REMOTE_GET_CARDS = `${URL_BASE}/api/protected/supervisor/getCards`
const URL_SUPERVISOR_REMOTE_UPDATE_CARDS = `${URL_BASE}/api/protected/supervisor/updateCards`

const URL_SUPERVISOR_REMOTE_GET_CONSISTENCY_LOGS = `${URL_BASE}/api/protected/supervisor/getConsistencyLogByCode2`
const URL_SUPERVISOR_REMOTE_GET_DATABASE_LOGS = `${URL_BASE}/api/protected/supervisor/getMaxDatesByCode1`

export default {
  URL_LOGIN,
  URL_GET_ITEMS,
  URL_REGISTER_VIEW,

  URL_EDIT_ITEM,
  URL_MOVE_ITEM,
  URL_HIDE_ITEM,
  URL_UNHIDE_ITEM,
  URL_REMOVE_ITEM,
  URL_UNDO_REMOVE_ITEM,
  URL_ADD_ITEM,
  URL_SET_FAVORITE,

  URL_UPDATE_USER_INFO,
  URL_UPDATE_USER_PASSWORD,

  URL_GET_ADMIN_USERS,
  URL_GET_ADMIN_SUBSCRIPTIONS,
  URL_GET_ADMIN_FOLDERS_SUBSCRIPTIONS,
  URL_UPDATE_SUBSCRIPTIONS,
  URL_ADMIN_UPDATE_USER_INFO,
  URL_ADMIN_UPDATE_USER_PASSWORD,
  URL_ADMIN_UPDATE_ACCESS_LEVEL,
  URL_ADMIN_CREATE_USER,

  URL_CREATE_STRUCTURE,
  URL_CHECK_STRUCTURE_NAME,
  URL_GET_STRUCTURES,
  URL_BUILD_STRUCTURE,
  URL_CREATE_HERITABLE_ITEM,
  URL_UPDATE_HERITABLE_ITEM,
  URL_CREATE_HERITABLE_STRUCTURE,
  URL_REPLICATE_STRUCTURE,
  URL_REMOVE_STRUCTURE,
  URL_UPDATE_SPECIFIC_ITEM_DATA,
  URL_REPLICATE_FOLDER,
  URL_UPDATE_MULTIPLE_ITEMS_INHERITEE,
  URL_GET_HERITABLE_ITEMS,

  URL_SUPERVISOR_REMOTE_FILES,
  URL_SUPERVISOR_REMOTE_UPDATE_FILE,
  URL_SUPERVISOR_REMOTE_REMOVE_FILE,
  URL_SUPERVISOR_REMOTE_ADD_DISTRIBUTOR,
  URL_SUPERVISOR_REMOTE_EDIT_DISTRIBUTOR,
  URL_SUPERVISOR_REMOTE_REMOVE_DISTRIBUTOR,
  URL_SUPERVISOR_REMOTE_SEND_INCONSISTENCIES_MAIL,

  URL_SUPERVISOR_REMOTE_GET_CARDS,
  URL_SUPERVISOR_REMOTE_UPDATE_CARDS,

  URL_SUPERVISOR_REMOTE_GET_CONSISTENCY_LOGS,
  URL_SUPERVISOR_REMOTE_GET_DATABASE_LOGS
}



// WEBPACK FOOTER //
// ./src/utils/uris.js